<template>
  <v-form>
    <!-- プロパティモーダル -->
    <v-dialog v-model="checkDialogVisible" max-width="300px" persistent>
      <v-card>
        <v-card-title>プロパティ編集</v-card-title>
        <v-card-text>
          <!-- プロパティ一覧 -->
          <!-- 検索候補リスト -->
          <v-list v-if="filteredProperties.length" style="margin-top: 10px">
            <v-list-item
                v-for="(property, index) in filteredProperties.filter(property => property.propertyName !== 'ステータス' && property.propertyType !== '8')"
                :key="index"
                class="d-flex align-center"
                style="border-bottom: 1px solid #ddd;"
                @click="toggleCheck(property)"
              >
              <div class="d-flex align-center" style="width: 100%;">
                <v-checkbox
                  v-model="property.isSelected"
                  :true-value="1"
                  :false-value="0"
                  color="primary"
                  hide-details
                  density="compact"
                  class="mr-2"
                  @click.stop 
                />
                <span>{{ property.propertyName }}</span>
                </div>
              </v-list-item>
          </v-list>
          <v-row>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn @click="checkProperty()">確認</v-btn>
              <v-btn class="ml-2" @click="closeProperty()">閉じる</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import propertyCheck from "@/api/propertyCheck";

export default {
  
  props: {
    selectedCardId: Number, // カードサイドバーのカードID
    propertyDialog: Boolean, // 親からのダイアログ表示状態
    tableId: Number,
    data: Object,
    properties: Array
  },
  data() {
    return {
      authUserId: localStorage.getItem("authUserId"),
      sessionKey: localStorage.getItem("sessionKey"),
      isRequired: null,
      checkDialogVisible: true,
      editPropertyDialog: false, // プロパティ編集画面表示状態
      editOptionDialog: false, // オプション編集画面表示状態
      propertySearch: "", // プロパティ検索用
      propertyName: "", // プロパティ名
      propertyType: "", // プロパティタイプ
      property: {},
      propertyId: null,
      isSelected: 0,
      propertyErrorMessages: { name: "", type: "" },
      optionErrorMessage: "", // エラーメッセージ用
      filteredProperties: [], 
    };
  },
  watch: {
    checkDialogVisible(newVal) {
      console.log("checkDialogVisibleの変更:", newVal);
      if (newVal === true) {
        this.checkDialogVisible = newVal;
        console.log("テーブルID:", this.tableId);
      }
    },
    data: {
      handler(newData) {
        console.log("dataの変更:", newData);
        this.filterProp();
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.filterProp();
  },
  methods: {
    async checkProperty() {
      try {
        const staffName = localStorage.getItem("staffName");
        const authUserId = localStorage.getItem("authUserId");
        const sessionKey = localStorage.getItem("sessionKey");
        const propertyList = this.filteredProperties
          .filter(p => p.propertyName !== "ステータス" && p.propertyType !== "8")
          .map(p => ({ propertyId: p.propertyId, isSelected: p.isSelected }));

        const res = await propertyCheck.checkProperty(authUserId, sessionKey, staffName, propertyList);

        if (res.status === 200) {
          alert("カード表示設定に成功しました");
          }
      } catch (err) {
        console.error("カード表示設定に失敗しました:", err);
      } finally {
        this.checkDialogVisible = false;
        this.$emit("update:checkDialogVisible", false);
        this.$emit("triggerSearch");
        this.$emit("refreshProperties");
      }
    },
    toggleCheck(property) {
      property.isSelected = property.isSelected === 1 ? 0 : 1;
    },
    filterProp() {
      console.log("sideBarからのプロパティ:", this.data);

      // Proxyオブジェクトの構造からデータを抽出
      const propertiesArray = this.data.data[0].properties || [];

      // 必要な情報を抽出
      this.filteredProperties = propertiesArray
        .map((item) => {
          const property = item.property || {};
          return {
            propertyId: property.propertyId,
            propertyName: property.propertyName,
            propertyType: property.propertyType,
            isSelected: property.isSelected
          };
        })
        .filter(
          (item) => item.propertyId && item.propertyName && item.propertyType
        ); // 全てのキーが存在する場合のみ格納

      console.log("CardEditのプロパティ情報3:", this.filteredProperties);
    },
    propertiesArray() {
      // データが適切に存在する場合のみ配列を返す
      if (
        this.data &&
        Array.isArray(this.data.data) &&
        this.data.data[0]?.properties &&
        Array.isArray(this.data.data[0].properties)
      ) {
        return this.data.data[0].properties;
      }
      console.warn(
        "propertiesが見つからない、または不正なデータ形式です:",
        this.data
      );
      return []; // デフォルト値
    },
    // プロパティ画面を閉じる
    closeProperty() {
      this.checkDialogVisible = false;
      this.$emit("update:checkDialogVisible", false);
    },
    }
};
</script>

<style scoped>
.form-header {
  background-color: #ffffff;
  /* 背景色を白色に */
  height: 150px;
  /* 高さを指定して色が表示される領域を作成 */
}

.custom-icon-margin {
  position: relative;
  margin-left: 150px;
  font-size: 18px;
  /* mdi-circleを小さくする */
}
</style>
